import { FiDownload } from "react-icons/fi";
import { Button } from "newui/components/Button";
import { buildDeliveryExportUrl } from "../api/notifications-api";
import { notificationsLang } from "../lang/en";
import type { NotificationDeliveryFilters } from "../types/Notifications.type";

export interface DeliveryAuditExportButtonProps {
	filters: Omit<NotificationDeliveryFilters, "page">;
}

// Triggers the CSV export via direct anchor navigation to the backend export
// endpoint (mirrors AuditExportButton.tsx, item-01 FE-5) — NOT an axios/fetch
// call, so there is no client-side CSV construction/reformatting.
export const DeliveryAuditExportButton = ({ filters }: DeliveryAuditExportButtonProps) => {
	const handleExport = () => {
		const url = buildDeliveryExportUrl(filters);
		const anchor = document.createElement("a");
		anchor.href = url;
		anchor.setAttribute("download", "");
		document.body.appendChild(anchor);
		anchor.click();
		document.body.removeChild(anchor);
	};

	return (
		<Button btntype="secondary" size="sm" onClick={handleExport} data-testid="delivery-audit-export-button">
			<span className="pr-2">
				<FiDownload size={16} />
			</span>
			{notificationsLang.auditExportButton}
		</Button>
	);
};
